import { render, staticRenderFns } from "./recycleListDetail.vue?vue&type=template&id=7d4ef668&scoped=true&"
import script from "./recycleListDetail.vue?vue&type=script&lang=js&"
export * from "./recycleListDetail.vue?vue&type=script&lang=js&"
import style0 from "./recycleListDetail.vue?vue&type=style&index=0&id=7d4ef668&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4ef668",
  null
  
)

export default component.exports